import type { RouteRecordRaw } from 'vue-router'
import PageHome from '@/views/app/home/page-home.vue'
import AuthRoutes from './modules/auth'
import BranchRoutes from './modules/branch'
import CompanyRoutes from './modules/company'
import CurrencyRoutes from './modules/currency'
import CustomerRoutes from './modules/customer'
import ErrorRoutes from './modules/error'
import MoveOrderRoutes from './modules/move-order'
import MoveOrderReceiptRoutes from './modules/move-order-receipt'
import PasswordRoutes from './modules/password'
import PaymentMethodRoutes from './modules/payment-method'
import PaymentMethodEdcRoutes from './modules/payment-method-edc'
import ProductRoutes from './modules/product'
import PurchaseRoutes from './modules/purchase'
import ReportPurchaseRoutes from './modules/report-purchase'
import ReportSaleRoutes from './modules/report-sale'
import ReportStockRoutes from './modules/report-stock'
import SaleRoutes from './modules/sale'
import SettingsRoute from './modules/settings'
import SpgPointRoute from './modules/spg-point'
import StockAdjustmentRoutes from './modules/stock-adjustment'
import StockOpnameRoutes from './modules/stock-opname'
import SupplierRoutes from './modules/supplier'
import UserAdminRoutes from './modules/useradmin'
import VoucherRoutes from './modules/voucher'

const routes: RouteRecordRaw[] = [
  layoutApp('/home', [
    {
      path: '/',
      name: 'home',
      component: PageHome,
      meta: { title: 'Dashboard' },
    },
    {
      path: '/riwayat-perubahan',
      name: 'changelogs',
      component: () => import('@/views/app/changelog/page-list.vue'),
      meta: { title: 'Riwayat Perubahan' },
    },
    {
      path: '/css',
      name: 'css',
      component: () => import('@/views/app/css/page-index.vue'),
      meta: { title: 'CSS' },
    },
    {
      path: '/hasil-ekspor-laporan',
      name: 'report export file',
      component: () => import('@/views/app/report-export-file/page-list.vue'),
      meta: { title: 'Hasil Ekspor Laporan' },
    },
  ]),
  layoutApp('/produk', ProductRoutes),
  layoutApp('/pelanggan', CustomerRoutes),
  layoutApp('/supplier', SupplierRoutes),
  layoutApp('/company', CompanyRoutes),
  layoutApp('/mata-uang', CurrencyRoutes),
  layoutApp('/cabang', BranchRoutes),
  layoutApp('/pembelian', PurchaseRoutes),
  layoutApp('/penjualan', SaleRoutes),
  layoutApp('/mutasi-barang', MoveOrderRoutes),
  layoutApp('/penerimaan-barang', MoveOrderReceiptRoutes),
  layoutApp('/penyesuaian-stok', StockAdjustmentRoutes),
  layoutApp('/payment-method-edc', PaymentMethodEdcRoutes),
  layoutApp('/payment-method', PaymentMethodRoutes),
  layoutApp('/laporan/stok', ReportStockRoutes),
  layoutApp('/laporan/pembelian', ReportPurchaseRoutes),
  layoutApp('/laporan/penjualan', ReportSaleRoutes),
  layoutApp('/pengguna', UserAdminRoutes),
  layoutApp('/ubah-password', PasswordRoutes),
  layoutApp('/pengaturan-sistem', SettingsRoute),
  layoutApp('/poin', SpgPointRoute),
  layoutApp('/stock-opname', StockOpnameRoutes),
  layoutApp('/voucher', VoucherRoutes),
  {
    path: '/cetak',
    component: () => import('@/views/print/the-layout.vue'),
    children: [
      {
        path: '/cetak-barcode',
        name: 'print barcode final',
        component: () => import('@/views/app/product/print-barcode/page-print.vue'),
        meta: { title: 'Cetak Barcode' },
      },
      {
        path: '/cetak-nota-jual/:saleId',
        name: 'print sales receipt',
        component: () => import('@/views/app/sale/receipt/page-receipt.vue'),
        meta: { title: 'Cetak Nota Jual' },
      },
    ],
  },

  AuthRoutes,
  ErrorRoutes,
  {
    path: '/akses-ditolak',
    name: 'forbidden',
    component: () => import('@/views/errors/error-403.vue'),
    meta: { title: 'Akses Ditolak' },
  },
]

export function layoutApp (path: string, children: RouteRecordRaw[]): RouteRecordRaw {
  return {
    path,
    children,
    component: () => import('@/views/app/the-layout.vue'),
  }
}

export default routes
